import { IconProps } from "@/icons/icon";
import { rem } from "@mantine/core";
import { memo } from "react";

export const X = memo(function X({ size = 16, style, ...others }: IconProps) {
  return (
    <svg
      style={{ width: rem(size), height: rem(size), ...style }}
      {...others}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <path d="M14.258 10.152L23.176 0h-2.113l-7.747 8.813L7.133 0H0l9.352 13.328L0 23.973h2.113l8.176-9.309 6.531 9.309h7.133zm-2.895 3.293l-.949-1.328L2.875 1.56h3.246l6.086 8.523.949 1.328 7.91 11.078h-3.246zm0 0" />
    </svg>
  );
});
